module.exports = __webpack_public_path__ + "img/PERCEPTION.87d6cdad.png";